import { assertNever } from 'libs/assert';
export const PRODUCT_BEEY = 'beey_';
export const PRODUCT_ND6 = 'nd6_';
export const PRODUCT_VIP_BEEY = 'vipbeey_';
export const PRODUCT_VIP_ND6 = 'vipnd6_';
export const PRODUCT_BEEY_ENTERPRISE = 'enterprise';
export const PLAN_KEY_BEEY_START = 'beey_start';
export const PRODUCT_ENTERPRISE = 'enterprise';
export const getProductFamily = (planKey) => {
    if (planKey.startsWith(`${PRODUCT_ND6}`) || planKey.startsWith(`${PRODUCT_VIP_ND6}`))
        return PRODUCT_ND6;
    if (planKey.startsWith(`${PRODUCT_BEEY}`) || planKey.startsWith(`${PRODUCT_VIP_BEEY}`))
        return PRODUCT_BEEY;
    if (planKey === PRODUCT_ENTERPRISE)
        return PRODUCT_ENTERPRISE;
    assertNever(false, `Unknown product family for planKey  ${planKey}`);
    return PRODUCT_BEEY; // This line will never be reached, but satisfies the linter
};
export const isBeeyPlan = (planKey) => getProductFamily(planKey) === PRODUCT_BEEY;
export const isND6Plan = (planKey) => getProductFamily(planKey) === PRODUCT_ND6;
export const isEnterprisePlan = (planKey) => planKey === PRODUCT_BEEY_ENTERPRISE;
export const isStartPlan = (planKey, isRecurring) => planKey === PLAN_KEY_BEEY_START && !isRecurring;
export const getProductEdition = (planKey) => {
    if (isBeeyPlan(planKey)) {
        return PRODUCT_BEEY;
    }
    const baseKey = planKey.replace(/_(monthly|yearly)$/, '');
    return baseKey;
};
export function isOtherEditionPlanActive(subscriptions, planKey) {
    const productEdition = getProductEdition(planKey);
    return subscriptions.some((sub) => sub.isActive
        && sub.items.length > 0
        && sub.items[0].planKey.startsWith(productEdition)
        && sub.items[0].planKey !== planKey
        && sub.items[0].planKey !== PLAN_KEY_BEEY_START);
}
export function getEditionSubscriptions(subscriptions, planKey) {
    const productEdition = getProductEdition(planKey);
    return subscriptions.filter((sub) => sub.items.length > 0
        && sub.items[0].planKey.startsWith(productEdition));
}
export function getActiveSubscriptionByPlanKey(subscriptions, planKey) {
    return subscriptions.find((sub) => sub.isActive
        && sub.items.length > 0
        && sub.items[0].planKey === planKey);
}
export function getSubscriptionByPlanKey(subscriptions, planKey) {
    return subscriptions.find((sub) => sub.items.length > 0
        && sub.items[0].planKey === planKey);
}
export function getActiveEditionSubscription(subscriptions, planKey) {
    return getEditionSubscriptions(subscriptions, planKey).find((sub) => sub.isActive);
}
